export default __webpack_public_path__ + "static/media/image-2.16e8b058.png";